<template>
  <section
    class="fixed top-0 right-0 h-full w-full border-l z-20 bg-white overflow-y-auto sm:w-120"
  >
    <div
      class="text-left pt-5 pb-6 px-5 border-b flex items-center justify-between"
    >
      <div class="flex items-center">
        <h4>Filtro</h4>
        <span
          class="ml-4 cursor-pointer text-secondary-500"
          @click="clearFilters"
        >
          Limpiar Filtros
        </span>
      </div>

      <div
        class="cursor-pointer"
        @click="$store.commit('videos/setShowFilter', false)"
      >
        <BaseIcon class="text-xl" name="times" />
      </div>
    </div>

    <div>
      <FilterTags />
      <!-- <FilterSpeakers /> -->
    </div>
  </section>
</template>

<script>
import clearFiltersMixin from '@/mixins/clearFiltersMixin'
// import FilterSpeakers from '@/components/VideosFilterSpeakers'
import FilterTags from '@/components/VideosFilterTags'

export default {
  components: { FilterTags },
  mixins: [clearFiltersMixin],

  mounted() {
    this.$store.dispatch(
      'videos/fetchVideosFilters',
      this.$route.name.toLowerCase()
    )
  },

  methods: {
    clearFilters() {
      this.$store.commit('videos/clearFilters')

      this.$store.dispatch(`videos/${this.videosAction}`, {
        slug: this.$route.params.slug,
      })
    },
  },
}
</script>
